import palette from "./palette";

export default {
  fontFamily: [
      'Source Sans Variable',
      'sans-serif',
    ].join(','),
  h1: {
    color: palette.black,
    fontWeight: "bold",
    fontSize: "50px",

    letterSpacing: "-0.12pt",
    lineHeight: "40px",
  },
  h2: {
    color: palette.lightblack,
    fontWeight: 500,
    fontSize: "30px",
    letterSpacing: "-0.24px",
    lineHeight: "32px",
  },
  h3: {
    color: palette.gray2,
    fontWeight: 500,
    fontSize: "20px",
    letterSpacing: "-0.06px",
    lineHeight: "28px",
    marginBottom: "20px",
  },
  h4: {
    color: palette.gray1,
    fontWeight: 500,
    fontSize: "16px",
    letterSpacing: "-0.06px",
    lineHeight: "24px",
  },
  h5: {
    color: palette.black,
    fontWeight: "bold",
    fontSize: "14px",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
  },
  h6: {
    color: palette.black,
    fontWeight: 500,
    fontSize: "14px",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
  },
  subtitle1: {
    color: palette.black,
    fontSize: "16px",
    letterSpacing: "-0.05px",
    lineHeight: "25px",
  },
  subtitle2: {
    color: palette.gray1,
    fontWeight: 400,
    fontSize: "14px",
    letterSpacing: "-0.05px",
    lineHeight: "21px",
  },
  body1: {
    color: palette.lightblack,
    fontSize: "14px",
    letterSpacing: "-0.05px",
    lineHeight: "21px",
  },
  body2: {
    color: palette.darkgray,
    fontSize: "12px",
    letterSpacing: "-0.04px",
    lineHeight: "18px",
  },
  button: {
    color: palette.text.primary,
    fontSize: "14px",
  },
  h5w: {
    color: palette.white,
    fontWeight: 500,
    fontSize: "16px",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
  },
  caption: {
    color: palette.gray1,
    fontSize: "11px",
    letterSpacing: "0.33px",
    lineHeight: "13px",
  },
  overline: {
    color: palette.text.secondary,
    fontSize: "11px",
    fontWeight: 500,
    letterSpacing: "0.33px",
    lineHeight: "13px",
    textTransform: "uppercase",
  },
  a1: {
    color: palette.white,
  },
};
